// src/api/prakriti.js

import axios from "axios";

const API = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

API.interceptors.request.use(
  (config) => {
    const authData = JSON.parse(localStorage.getItem("authData") || "null");
    if (authData?.accessToken) {
      config.headers.Authorization = `Bearer ${authData.accessToken}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

/**
 * Get all Prakriti questions
 */
export const getPrakritiQuestions = () => API.get("/prakriti/questions");

/**
 * Create a new Prakriti assessment
 * @param {Object} data
 */
export const createPrakritiAssessment = (data) => API.post("/prakriti", data);

/**
 * Get all Prakriti assessments for a patient
 * @param {string} patientId
 */
export const getPatientPrakritiHistory = (patientId) => API.get(`/prakriti/patient/${patientId}`);

/**
 * Get single assessment by ID
 * @param {string} id
 */
export const getPrakritiAssessmentById = (id) => API.get(`/prakriti/${id}`);

/**
 * Update Prakriti assessment by ID
 * @param {string} id
 * @param {Object} data
 */
export const updatePrakritiAssessment = (id, data) => API.put(`/prakriti/${id}`, data);

/**
 * Delete Prakriti assessment by ID
 * @param {string} id
 */
export const deletePrakritiAssessment = (id) => API.delete(`/prakriti/${id}`);
